import { $Q, $Qll } from "../utils/query-selector";
import { btnAddToCart } from "./cart";
import { setupCustomSelect } from './custom-select';

/**
 * Add price to main button page product when the product is out of stock
 */
export const priceAutOfStock = () => {
  let triggerElement = $Qll('button#SI_trigger[data-price]'); 
  if (!triggerElement || !triggerElement[0] || !triggerElement[1]) return
  triggerElement[0].innerText = triggerElement[1].innerText
  if(triggerElement.length != 2) return ;
  const config = { attributes: true, childList: true, subtree: true };
  const callback = ()=>{
    if(triggerElement[0].innerText == triggerElement[1].innerText) return ;
    triggerElement[0].innerText = triggerElement[1].innerText
  }
  const observer = new MutationObserver(callback);
  observer.observe(triggerElement[0], config); 
}
